import "./Link_module.css";
const Link_module = {
    link: "link__9585fb2f3ecc1375"
};
export { Link_module as default };
